import { render, staticRenderFns } from "./sdkItem.vue?vue&type=template&id=d255afc4&scoped=true&"
import script from "./sdkItem.vue?vue&type=script&lang=js&"
export * from "./sdkItem.vue?vue&type=script&lang=js&"
import style0 from "./sdkItem.vue?vue&type=style&index=0&id=d255afc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d255afc4",
  null
  
)

export default component.exports